"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _connectToWebChat.default)(function (_ref) {
  var styleSet = _ref.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref2) {
  var ariaLabel = _ref2['aria-label'],
      children = _ref2.children,
      className = _ref2.className,
      fromUser = _ref2.fromUser,
      styleSet = _ref2.styleSet;
  return _react.default.createElement("div", {
    "aria-label": ariaLabel,
    className: (0, _classnames.default)(styleSet.bubble + '', {
      'from-user': fromUser
    }, (className || '') + '')
  }, children);
});

exports.default = _default;